module.exports = __webpack_public_path__ + "img/mo.50bb5366.gif";